import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const PAGE_SIZE_OPTIONS = [25, 50, 100] as const

export const Route = createFileRoute("/_layout/WMS/ksef/fz")({
  validateSearch: (search: Record<string, unknown>) => {
    const rawPage =
      typeof search.page === "number" ? search.page : Number(search.page ?? 1)
    const rawPageSize =
      typeof search.page_size === "number"
        ? search.page_size
        : Number(search.page_size ?? 50)
    const normalizedPageSize = PAGE_SIZE_OPTIONS.includes(
      rawPageSize as (typeof PAGE_SIZE_OPTIONS)[number],
    )
      ? rawPageSize
      : 50

    return {
      page:
        Number.isFinite(rawPage) && Number.isInteger(rawPage) && rawPage > 0
          ? rawPage
          : 1,
      page_size: normalizedPageSize,
    }
  },
  component: KSeFFZRegisterRoute,
})

const KSeFFZRegisterPage = lazy(
  () => import("../../../../components/WMS/KSeF/KSeFFZRegisterPage.tsx"),
)

function KSeFFZRegisterRoute() {
  return (
    <LazyRoutePage>
      <KSeFFZRegisterPage />
    </LazyRoutePage>
  )
}
